import { useIonModal } from '@ionic/react';
import classNames from 'classnames';
import { Business } from 'model';
import { useClaimBusinessMutation } from '../api/BusinessApi';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { Confirmation } from '../pages/Confirmation';
import { getDomain } from '../util/domain';
import styles from './ClaimBusinessBanner.module.css';
import { IconButton } from './IconButton';
import { IconCheckCircle, IconShield } from './QuirkIcons';

export function ClaimBusinessBanner({ business }: { business: Business }): JSX.Element | null {
	const { _id, claimStatus, website } = business;
	const user = useCurrentUser();
	const [, emailDomain] = user.email.split('@', 2);
	const siteDomain = getDomain(website);
	const [triggerMutation, { isLoading }] = useClaimBusinessMutation();
	const triggerClaim = () => {
		dismissWarning();
		triggerMutation({ business: _id });
	};
	const [showWarning, dismissWarning] = useIonModal(Confirmation, {
		onDismiss: () => dismissWarning(),
		action: triggerClaim,
		actionLabel: 'Proceed with this account',
		dismissLabel: 'Cancel',
		content: (
			<div className={styles.warningModal}>
				<div className={styles.iconWrapper}>
					<IconShield size="xlarge" />
				</div>

				<div className={styles.warningWrapper}>
					<h4 style={{ marginBottom: '40px' }}>
						Claiming the business allows you greater control over the content of this business listing. You
						should be the owner, or an employee of the business who is authorized to edit this listing.
					</h4>
					<p>
						Your email address domain of <span className={styles.domainName}>{emailDomain}</span> does not
						match the website domain of <span className={styles.domainName}>{siteDomain}</span> for this
						business.
					</p>
					<p>It is reccomended that you create an account with a matching domain to claim this business.</p>
				</div>
			</div>
		)
	});
	const handleClaim = () => {
		if (siteDomain !== emailDomain) {
			showWarning();
		} else {
			triggerClaim();
		}
	};

	if (claimStatus !== 'unclaimed') {
		return null;
	}
	return (
		<div className={classNames(styles.claimBanner, styles[claimStatus])}>
			<span>Do you own or operate this business?</span>
			<IconButton icon={<IconCheckCircle />} label={'Claim it'} onClick={handleClaim} disabled={isLoading} />
		</div>
	);
}
